export interface IRole {
	_id: string;
	id: string;
	code: string;
	name: string;
	actionIds?: string[];
	actions?: string[]; // Array of action IDs (strings)
	accountId: string;
	status: string;
	ouLevel: string;
	level: number;
	type: string;
	createdAt: Date;
	updatedAt: Date;
}

export enum RoleType {
	STANDARD_SYSTEM_ROLES = "STANDARD_SYSTEM_ROLES",
	STANDARD_ACCOUNT_ROLES = "STANDARD_ACCOUNT_ROLES",
	CUSTOM_ROLES = "CUSTOM_ROLES",
}
